module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt3_m.f0264304bebe5107ed2c5ed341cd5a2f.png";